import { Box, Button, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { memo, useCallback } from 'react';
import { OptedInPromoBottomSheetProps } from './OptedInPromo.types';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import {
  getPromos,
  optIn,
  selectOptInPending,
} from '../../../state/promos/promos.slice';

function OptedInPromo({
  handleCtaAction,
  promotionId,
  promoType,
  newPromoName,
  oldPromoName,
  close,
}: OptedInPromoBottomSheetProps) {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectOptInPending(promotionId));
  const [t] = useTranslation('promos');

  const handleOnPress = useCallback(async () => {
    const result = await dispatch(optIn(promotionId));

    if (result.meta.requestStatus === 'fulfilled') {
      dispatch(getPromos());
      handleCtaAction();
      close();
    }
  }, [dispatch, promotionId, handleCtaAction, close]);

  return (
    <Box gap="space-200">
      <Text variant="h5" color="darkSurfacePrimary">
        Continue?
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary">
        {t('multiplePromos', {
          context: promoType === 'Cashback' ? 'cashback' : 'other',
          newPromoName,
          oldPromoName,
        })}
      </Text>
      <Button
        variant="primary"
        locNS="common"
        locKey="continue"
        width="100%"
        marginTop="space-200"
        loading={isLoading}
        onPress={handleOnPress}
      />
    </Box>
  );
}

export default memo(OptedInPromo);
